import { mapState, mapActions } from 'vuex';
import messages from './exchange-rate-lang.json';
import exchangeRateForm from './exchange-rate-form/exchange-rate-form.vue';
import exchangeRateResults from './exchange-rate-results/exchange-rate-results.vue';
const EXCHANGE_RATE_TYPES = {
	exchange: 'ARF_OTP',
	MNB: 'ARF_MNB',
	foreign: 'ARF_KUL,ARF_EKUL'
};
export default {
	props: {
		type: {
			type: String,
			required: true,
			validator(value) {
				return value == 'exchange' || value == 'MNB' || value == 'foreign';
			}
		},
		exchangeRateAfirUrl: {
			type: String
		},
		exchangeRateCardUrl: {
			type: String
		},
		exchangeRateConversionUrl: {
			type: String
		},
		editedLinks: {
			type: Boolean
		}
	},
	data() {
		return {};
	},
	i18n: { messages },
	components: {
		'exchange-rate-form': exchangeRateForm,
		'exchange-rate-results': exchangeRateResults
	},
	computed: {
		exchangeRateType() {
			let type;
			if (this.type == 'foreign') {
				if (this.foreignType == 'standard') {
					type = 'ARF_KUL';
				} else {
					type = 'ARF_EKUL';
				}
			} else {
				type = EXCHANGE_RATE_TYPES[this.type];
			}
			return type;
		},
		actualMessages() {
			return this.messages && this.messages[this.exchangeRateType];
		},
		...mapState('exchangeRate', ['technicalError', 'loading', 'versionInfo', 'results', 'version', 'date', 'currencies', 'foreignType', 'messages'])
	},
	methods: {
		dateChanged(type, date) {
			this.setDate(date);
			this.getVersions({ type, date });
		},
		...mapActions('exchangeRate', [
			'setDate',
			'getVersions',
			'setVersion',
			'calculate',
			'resetResults',
			'getCurrencies',
			'setTechnicalError',
			'setForeignType',
			'getMessages'
		])
	},
	created() {
		this.getMessages(EXCHANGE_RATE_TYPES[this.type]);
	}
};
